const baseStyle = () => ({
  root: {},
});

const theme = { baseStyle };
export default theme;
